<capra-avatar
  [class.loading]="loading"
  [type]="capraAvatarType"
  [size]="capraAvatarSize"
  [community]="isCommunity"
  [options]="options"
></capra-avatar>
